import { Fancybox } from "@fancyapps/ui";

interface FancyboxOptions {
    [key: string]: any;
}

interface FancyboxItem {
    src: string;
    type: string;
}

declare global {
    interface Window {
        Fancybox?: {
            show?: (items: FancyboxItem[], options?: FancyboxOptions) => void;
            open?: (items: FancyboxItem[], options?: FancyboxOptions) => void;
        };
    }
}

/**
 * Initializes Fancybox with the given images and options.
 * Handles different Fancybox global references for compatibility.
 * @param images - Array of image URLs.
 * @param options - Fancybox options.
 */
export function initializeFancybox(images: string[], options?: FancyboxOptions): void {
    const items: FancyboxItem[] = images.map((img) => ({ src: img, type: "image" }));

    if (window.Fancybox && window.Fancybox.show) {
        window.Fancybox.show(items, options);
    } else if (window.Fancybox && window.Fancybox.open) {
        window.Fancybox.open(items, options);
    } else if (Fancybox && Fancybox.show) {
        Fancybox.show(items, options);
    }
}
